<template>
  <router-view  v-if="this.getLanguage.length!=0 && getUserInfo.AT != null &&  getUserInfo.AT != undefined"></router-view>
</template>

<script>

import {mapGetters, mapActions} from 'vuex'

export default {
  name: 'App',
  computed:{
	...mapGetters('Language', [
    'getLanguage',
    'getLanguageOPT',
    'getLanguageIndex',
    'getLangTreeSelect'
    ]),
      ...mapGetters('UserInfo', ['getUserInfo','getMenuDisplayType']),
  },

  methods: {
    ...mapActions('Language', ['setLanguage','setLanguageIndex']),
    ...mapActions('UserInfo', ['setUser']),
  },
  created(){
    let lang = window.localStorage.getItem('lang') || "en";
    this.setLanguage(lang);
    this.$root.Language.getLanguage(this, lang);
    this.$root.UserInfo.getInfoApi(this);
  }
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>



// WEBPACK FOOTER //
// src/App.vue